import Swal from 'sweetalert2';
import axios from 'axios';
import template from './VatPromptComponent.html';

export default {
  template,

  data() {
    return {
      csrfToken: window.Laravel.csrfToken,
    };
  },

  mounted() {
    this.openModal();
  },

  methods: {
    openModal() {
      Swal.fire({
        title: 'Vennligst velg portal',
        showConfirmButton: false,
        html: this.$el,
      }).then((result) => {
        if (typeof result.dismiss !== 'undefined') {
          // Set session to showVAT true if modal is rejected
          axios.post('/setShowVAT');
        }
      });
    },
  },
};
